import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

const downloadAnalyticsJobs = async (jobId: number): Promise<Blob> => {
  return apiClient
    .get(`${ENDPOINTS.ANALYTICS_JOB_FILTER_EXCEL_DOWNLOAD(jobId.toString())}`)
    .blob();
};

export const useDownloadAnalyticsJobsQuery = (
  jobId: number | null,
  options?: Omit<UseQueryOptions<Blob, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["downloadAnalyticsJobs", jobId],
    queryFn: () => {
      if (jobId === null) {
        throw new Error("jobId is null");
      }
      return downloadAnalyticsJobs(jobId);
    },
    enabled: false, // This ensures the query doesn't run automatically
    ...options,
  });
};
